import React, { FC } from 'react';
import { useDrop } from 'react-dnd';
import Field, { IField } from '../Field/Field';
import { canMovePlayer, movePlayer } from '../Game/Game';

import { ItemTypes } from '../Player/constants';
import { IPlayer } from '../../../../shared/types/player.type';

interface IBoardSquare {
  x: number;
  y: number;
  id?: number;
  innerRef: any;
  selectedPlayer: number | null;
}

type Props = IBoardSquare & IField & { children: React.ReactNode };
const BoardSquare: FC<Props> = (props) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.PLAYER,
      canDrop: () =>
        canMovePlayer(props.x, props.y, !!props.isEmpty, !!props.isAccessible),
      drop: (item) => {
        let prop = item as IPlayer;
        if (prop.number === props.selectedPlayer) {
          movePlayer(props.x, props.y, prop.id);
        }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [props.x, props.y, props.isAccessible],
  );
  return (
    <div ref={drop}>
      <Field {...props} innerRef={props.innerRef} $isOver={Boolean(isOver)}>
        {props.children}
      </Field>
    </div>
  );
};

export default BoardSquare;
